export const FileTypeConstants = {
  PDF: 'pdf',
  XLSX: 'xlsx',
  XLS: 'xls',
  DOCX: 'docx',
  DOC: 'doc',
  PPTX: 'pptx',
  PPT: 'ppt',
  JPG: 'jpg',
  JPEG: 'jpeg',
  PNG: 'png',
  GIF: 'gif',
  BMP: 'bmp',
  TXT: 'txt',
  ZIP: 'zip',
  RAR: 'rar',
  WEBP: 'webp',
  SVG: 'svg',
  RTF: 'rtf',
  CSV: 'csv',
  TAR: 'tar',
  GZ: 'gz',
};

export const ACCEPTED_FILE_EXTENSIONS = [
  '.pdf',
  '.doc',
  '.docx',
  '.xls',
  '.xlsx',
  '.jpg',
  '.jpeg',
  '.png',
  '.txt',
];

// The one extension -> MIME table. Read it through getMimeTypeForExtension
// (exportService) rather than indexing it directly.
export const FILE_TYPE_MIME_MAP: { [key: string]: string } = {
  pdf: 'application/pdf',
  doc: 'application/msword',
  docx: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  xls: 'application/vnd.ms-excel',
  xlsx: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  ppt: 'application/vnd.ms-powerpoint',
  pptx: 'application/vnd.openxmlformats-officedocument.presentationml.presentation',
  jpg: 'image/jpeg',
  jpeg: 'image/jpeg',
  png: 'image/png',
  gif: 'image/gif',
  bmp: 'image/bmp',
  txt: 'text/plain',
  zip: 'application/zip',
  rar: 'application/vnd.rar',
  '7z': 'application/x-7z-compressed',
};

export const DEFAULT_MIME_TYPE = 'application/octet-stream';

export const MAX_FILE_SIZE_MB = 25;
export const MAX_FILE_COUNT = 10;
export const BYTES_PER_KILOBYTE = 1024;
export const BYTES_PER_MEGABYTE = BYTES_PER_KILOBYTE * 1024;
